import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {
  fetchRequests,
  fetchCompanies,
  removeRequest,
} from "../../store/actions/index";
import { getSoPlanningUsers } from "../../store/external/soplanning";

import axios from "../../axios-atis";
import withErrorHandler from "../../hoc/withErrorHandler/withErrorHandler";
import { FormGroup, InputGroup, Button, Row, Col } from "react-bootstrap";
import RequestTable from "../../components/UI/Widget/RequestTable";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { isA, isReporter } from "../../store/utility";
import Switch from "rc-switch";
import { isEqual, isNull, isArrayLikeObject } from "lodash";
import { CSVLink } from 'react-csv';
import * as UIConstants from "../../components/UI/UIConstants";
import CloseOldModal from "../Modal/CloseOldModal";

// Persistance des filtres de la liste des demandes : on garde les filtres choisis
// par l'utilisateur (dates, relances/annulees/supprimees) d'une visite a l'autre
// de cette page, plutot que de les reinitialiser a chaque montage du composant.
const REQUEST_LIST_FILTERS_STORAGE_KEY = "atis.requestList.filters";

function loadPersistedRequestListFilters() {
  try {
    const raw = window.localStorage.getItem(REQUEST_LIST_FILTERS_STORAGE_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw);
    return {
      startingDate: parsed.startingDate ? moment(parsed.startingDate) : undefined,
      endingDate: parsed.endingDate ? moment(parsed.endingDate) : undefined,
      displayDeleted: typeof parsed.displayDeleted === "boolean" ? parsed.displayDeleted : undefined,
      displayCanceled: typeof parsed.displayCanceled === "boolean" ? parsed.displayCanceled : undefined,
      displayRelance: typeof parsed.displayRelance === "boolean" ? parsed.displayRelance : undefined,
    };
  } catch (e) {
    // Stockage local indisponible (navigation privee, quota, etc.) : on ignore.
    return null;
  }
}

function persistRequestListFilters(filters) {
  try {
    window.localStorage.setItem(
      REQUEST_LIST_FILTERS_STORAGE_KEY,
      JSON.stringify({
        startingDate: filters.startingDate ? filters.startingDate.toISOString() : null,
        endingDate: filters.endingDate ? filters.endingDate.toISOString() : null,
        displayDeleted: filters.displayDeleted,
        displayCanceled: filters.displayCanceled,
        displayRelance: filters.displayRelance,
      })
    );
  } catch (e) {
    // Stockage local indisponible : on continue sans persister, pas bloquant.
  }
}


class RequestList extends React.Component {
  constructor(props) {
    super(props);
    var idLocale = require("moment/locale/fr");
    moment.locale("id", idLocale);
    const persistedFilters = loadPersistedRequestListFilters() || {};
    this.state = {
      all_data: [],
      data: [],
      data_filtred: [],
      loading: true,
      loadingPlanningUsers:true,
      pages: null,
      page: 0,
      pageSize: 20,
      sorted: null,
      filtred: null,
      showRequestModal: false,
      showNewRequestModal: false,
      selectedRow: null,
      sections: [],
      companies: [],
      company: null,
      displayDeleted: persistedFilters.displayDeleted !== undefined ? persistedFilters.displayDeleted : false,
      displayCanceled: persistedFilters.displayCanceled !== undefined ? persistedFilters.displayCanceled : false,
      displayRelance: persistedFilters.displayRelance !== undefined ? persistedFilters.displayRelance : false,
      startingDate: moment().subtract(6, 'months'),
      endingDate: moment(),
      planningUsers: [],
      forceEmpty: false,
      showCloseOldModal: false,
    };
  }

  loadSoPlanningUsers() {
    getSoPlanningUsers().then((response) => {
      let soPlanningUsers = []
      if (response.status === 200) {
        soPlanningUsers = response.data.data
      }
      
      const planningUsers = soPlanningUsers.map(planningUser => {
        return {label: planningUser.name, value: planningUser.id}
      });
      
      this.setState({loadingPlanningUsers: false, planningUsers})
    })
  }
  componentDidMount() {
    this.loadRequests();
    this.props.dispatch(fetchCompanies());
    if (isA() || isReporter()) {
      this.loadSoPlanningUsers();
    }

  }

  componentWillReceiveProps(nextProps) {
    console.log("componentWillReceiveProps", nextProps)
    //const {displayDeleted, displayCanceled } = this.state;
    //console.log("componentWillReceiveProps", nextProps);
    let { loading, data, companies, company } = this.state;
    let addExtraState = false;
    
    if (!isNull(nextProps.companies) && isArrayLikeObject(nextProps.companies) && 
        !isEqual(nextProps.companies, this.state.companies)) {  
      addExtraState = true;
      companies = nextProps.companies.sort((a, b) => {
        return a.name.trim().localeCompare(b.name.trim(), "fr-FR");
      });
    }
    if (!isNull(nextProps.company) && !isEqual(company, nextProps.company)) {
      addExtraState = true;
      company = nextProps.company;
    }

    if (loading !== nextProps.loading) {
      loading = nextProps.loading;
      addExtraState = true;
    }

    if (
      !nextProps.loading &&
      !isNull(nextProps.requests) &&
      isArrayLikeObject(nextProps.requests) &&
      !isEqual(data, nextProps.requests)
    ) {
      data = nextProps.requests;
      addExtraState = true;
    }
    /*if (!isNull(nextProps.requests) && isArrayLikeObject(nextProps.requests) && 
        !isEqual(data, nextProps.requests)) {
      console.log("Loading from requests:", loading, nextProps.loading)
      addExtraState = true;
      data = nextProps.requests;
    }
    if (loading !== nextProps.loading) {
      addExtraState = true;
      console.log("Loading from receive props:", loading, nextProps.loading)
      loading = nextProps.loading;
    }*/
    if (addExtraState) {
      this.setState({
        loading: loading,
        pages: data.size,
        all_data: data,
        data: data,
        companies: companies,
        company: company,
      });
    }
    /*
    if (loading !== nextProps.loading &&
      //!isNull(nextProps.requests) &&
      isArrayLikeObject(nextProps.requests) &&
      !isEqual(nextProps.requests, data) &&
      isArrayLikeObject(nextProps.companies) &&
      isNull(nextProps.error)
    ) {
      console.log("Je rentre");
      const data = this.getCanceledRequests(nextProps.requests, displayCanceled);
      this.setState({
        loading: nextProps.loading,
        pages: nextProps.requests.size,
        all_data: nextProps.requests,
        data: data,
        companies: companies,
        company: nextProps.company,
      });
    } else if (isArrayLikeObject(nextProps.requests)) {
      console.log("Je rentre 2");
      const data = this.getCanceledRequests(nextProps.requests, displayCanceled);
      this.setState({
        pages: nextProps.requests.size,
        data: data,
        all_data: nextProps.requests,
        loading: nextProps.loading,
      });
    } else  if (this.props.loading !== nextProps.loading) {
      console.log("Je rentre 3");
      if (this.props.dispayDeleted === nextProps.dispayDeleted) {
        this.setState({
          loading: nextProps.loading,
        });
      }
    } else if (!isEqual(this.props.companies, nextProps.companies)) {
      console.log("Je rentre 4");
      console.log("Load Companies", nextProps.companies);
      this.setState({
        companies: nextProps.companies,
      });
    } else if (!isEqual(this.props.company, nextProps.company)) {
      console.log("Je rentre 5");
      this.setState({
        company: nextProps.company,
      });
    }*/
  }

  changeDisplayInputHandler = (displayDeleted) => {
    this.setState({ displayDeleted, displayRelance: false, displayCanceled: false, data_filtred: [], data: [] }, () => {
      persistRequestListFilters(this.state);
      this.props.dispatch(
        fetchRequests(
          this.state.startingDate.format("DD-MM-YYYY"),
          this.state.endingDate.format("DD-MM-YYYY"),
          displayDeleted,
          this.loading = !displayDeleted,
          this.state.page,
          this.state.pageSize,
          this.state.sorted,
          this.state.filtred
        )
      );
    });
    
  };

  getCanceledRequests(_data, displayCanceled) {
    // ATIS-FILTRE-ANNULEES 12/10/2026 : interrupteur actif = uniquement les annulees
    if (!_data) return _data;
    return displayCanceled
      ? _data.filter((d) => d.status === 2)
      : _data.filter((d) => d.status !== 2);
  }

  changeDisplayRelanceHandler = (displayRelance) => {
    const data_filtred = this.state.data.filter(
      (d) =>
        d.requestMessages &&
        d.requestMessages.length > 0 &&
        d.requestMessages.some((rm) => rm.requestType === "RELANCE")
    );

    this.setState({ displayRelance, data_filtred }, () => persistRequestListFilters(this.state));
  };

  changeDisplayCanceledHandler = (displayCanceled) => {
    const data = this.getCanceledRequests(this.state.all_data, displayCanceled);
    this.setState({ displayCanceled, data }, () => persistRequestListFilters(this.state));
  };

  startingDateHandler = (_startingDate) => {
    this.setState({ startingDate: _startingDate }, () => persistRequestListFilters(this.state));
  };

  endingDateHandler = (_endingDate) => {
    this.setState({ endingDate: _endingDate }, () => persistRequestListFilters(this.state));
  };

  refreshRequestsHandler = (event) => {
    event.preventDefault();
    console.log("refreshRequestsHandler: ",this.state.request)
    this.setState(
      { loading: true, date: [], data: [], data_filtred: [],forceEmpty: true,},
      () => {
        this.loadRequests();
      }
    );
    //this.loadRequests();
  };

  componentDidUpdate(prevProps) {
    if (prevProps.loading && !this.props.loading && this.state.forceEmpty) {
      this.setState({ forceEmpty: false });
    }
  }

  loadRequests = () => {
    console.log("reload Data (loadRequests)", Date.now(), this.state.data)
    
    this.props.dispatch(
      fetchRequests(
        this.state.startingDate.format("DD-MM-YYYY"),
        this.state.endingDate.format("DD-MM-YYYY"),
        this.state.displayDeleted,
        this.state.page,
        this.state.pageSize,
        this.state.sorted,
        this.state.filtred,
      )
    );
    console.log("reload Data (loadRequests)", this.state.data)
  };
  getCsvData = () => {
    const { displayRelance, data_filtred, data } = this.state;
    const _datas = displayRelance ? data_filtred : data;
    //console.log(_datas);
    let csvData = [["Numéro", "Libellé", "Demandeur", "Site", "Créée le", "Planifiée le", "Date d'intervention", "Status", "Bon d'intervention"]];
    //console.log("Headers", csvData);
    for (let i=0; i<_datas.length; i++) {
      const d = _datas[i];
      let _status = this.getStatus(d.status);
      const _hasPdf = d.hasPdf ? "OUI": "NON";
      const executedAt = isNull(d.executedAt) ? "": d.executedAt;
      const predictedAt = isNull(d.predictedAt) ? "": d.predictedAt;
      csvData.push([d.numRequest, d.name, d.company, d.section, d.createdAt, predictedAt, executedAt, _status, _hasPdf]);
    }
     
    
    return csvData;
  };

  getStatus = (status) => {
    //console.log("GETSTATUS");
    //console.log(status);
    const res = UIConstants.REQUEST_STATUS_TXT.filter(r => r.name === status);
    if (res.length === 1) {
      return res[0].label;
    }

    return "N/D";
  };

  removeRowHandler = (request) => {
    if (request !== undefined && request.id !== null) {
      request.deleted = !request.deleted;
      this.props.dispatch(removeRequest(request));
      this.forceUpdate();
    }
  };

  onPatchRequest = (id, patch) => {
    console.log("onPatchRequest")
  this.setState(prev => ({
    data: prev.data.map(r => (r.id === id ? { ...r, ...patch } : r))
  }));
};

  render() {
    const { error } = this.props;
    if (error) {
      return <div>Erreur : {error.message}</div>;
    }
    const { data, loading, data_filtred, companies, company, displayRelance, displayDeleted, startingDate, endingDate, displayCanceled, planningUsers } = this.state;
    console.log("data from List: ", data);
    console.log("loading from List: ", loading);
    //const datas = this.getCanceledRequests(data, displayCanceled)
    const newRequestRoute = isA() ? "/admin_request" : "request";

    const base = this.state.displayRelance ? this.state.data_filtred : this.getCanceledRequests(this.state.data, this.state.displayCanceled);
    const tableData = this.state.forceEmpty ? [] : base;

    return (
      <div className="content-wrapper">
        <div className="content-heading" style={{marginLeft: '-10px'}}>Interventions</div>
        <Row className="inline form-group" style={{ marginBottom: "0" }}>
          <Col sm={8} xs={12} xsHidden>
            <FormGroup>
              <InputGroup>
                <InputGroup.Addon>Du</InputGroup.Addon>
                <DatePicker
                  selected={startingDate}
                  className="form-control"
                  style={{ zIndex: 9999999, cursor: "pointer" }}
                  id="startingDate"
                  onChange={(_startingDate) =>
                    this.startingDateHandler(_startingDate)
                  }
                  locale="fr"
                />
                <InputGroup.Addon>Au</InputGroup.Addon>
                <DatePicker
                  selected={endingDate}
                  className="form-control"
                  style={{ zIndex: 9999999, cursor: "pointer" }}
                  id="endingDate"
                  onChange={(_endingDate) =>
                    this.endingDateHandler(_endingDate)
                  }
                  locale="fr"
                />
                <InputGroup.Button><Button
              bsStyle="success"
              onClick={(event) => this.refreshRequestsHandler(event)}
            >
              <span className="fa fa-refresh" />
              &nbsp;Rafraîchir
            </Button></InputGroup.Button>
              </InputGroup>  
              
            </FormGroup>
            
          </Col>
          <Col xs={12} smHidden mdHidden lgHidden>
            <FormGroup>
              <InputGroup>
                <InputGroup.Addon>Du</InputGroup.Addon>
                <DatePicker
                  selected={startingDate}
                  className="form-control"
                  style={{ zIndex: 9999999, cursor: "pointer" }}
                  id="startingDate"
                  onChange={(_startingDate) =>
                    this.startingDateHandler(_startingDate)
                  }
                  locale="fr"
                />
                <InputGroup.Addon>Au</InputGroup.Addon>
                <DatePicker
                  selected={endingDate}
                  className="form-control"
                  style={{ zIndex: 9999999, cursor: "pointer" }}
                  id="endingDate"
                  onChange={(_endingDate) =>
                    this.endingDateHandler(_endingDate)
                  }
                  locale="fr"
                />
              </InputGroup>  
            </FormGroup>
          </Col>
          <Col smHidden mdHidden lgHidden xs={12}>
            <Button
              style={{ width: '100%', margin: '10px', marginRight: '10px'}}
              
              bsStyle="success"
              onClick={(event) => this.refreshRequestsHandler(event)}
            >
              <span className="fa fa-refresh" />
              &nbsp;Rafraîchir
            </Button>
          </Col>
          <Col xsHidden sm={4}>
            <Link to={newRequestRoute} replace={true}>
              <Button bsStyle="primary" className="pull-right">
                <span className="fa fa-plus-square" />
                &nbsp;Nouvelle demande
              </Button>
            </Link>
          </Col>
        </Row>
        {isA() || isReporter() ? (
          <Row style={{ paddingBottom: "10px"  }}>
            <Col sm={3} style={{ textAlign: "right", paddingLeft: '0'}}>
              Relances{" "}
              <Switch
                checked={displayRelance}
                onChange={(event) => this.changeDisplayRelanceHandler(event)}
              />
            </Col>
            {isA() ? null : (<Col sm={3}></Col>)}
            <Col sm={3} style={{ textAlign: "right", paddingLeft: '0' }}>
              Demandes annulées{" "}
              <Switch
                checked={displayCanceled}
                onChange={(event) => this.changeDisplayCanceledHandler(event)}
              />
            </Col>
            <Col sm={3} style={{ textAlign: "right", paddingLeft: '0' }} >
              Demandes supprimées{" "}
              <Switch
                checked={displayDeleted}
                onChange={(event) => this.changeDisplayInputHandler(event)}
              />
            </Col>
            {isA() ? (<Col sm={3} style={{ textAlign: "right" }}>
              <Button
                bsStyle="warning"
                style={{ marginRight: "8px" }}
                onClick={() => this.setState({ showCloseOldModal: true })}
              >
                <span className="fa fa-check-square-o" />
                &nbsp;Clôturer les anciennes
              </Button>
              <CSVLink 
                data={this.getCsvData()}
                separator={";"}
                filename="export-atis.csv"
                className="btn btn-primary"
                target="_blank">
                  Exporter au format CSV
              </CSVLink>
            </Col>) : null}
          </Row>
        ) : null}
        {isA() ? (
          <CloseOldModal
            show={this.state.showCloseOldModal}
            onClose={() => this.setState({ showCloseOldModal: false })}
            onDone={() => this.refreshRequestsHandler({ preventDefault: () => {} })}
          />
        ) : null}
        <RequestTable
          data={tableData}
          loading={this.props.loading}
          companies={companies}
          company={company}
          removeRowHandler={this.removeRowHandler}
          planningUsers={planningUsers}
          onPatchRequest={this.onPatchRequest}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const reqLoading = !!state.request.loading;
  const compLoading = !!state.company.loading;

  return {
    requests: state.request.requests || [],
    error: state.request.error,
    loading: reqLoading || compLoading,
    error: state.request.error || null,
    userId: state.auth.userId,
    isAuthenticated: state.auth.token !== null,
    companies: state.company.companies,
    company: state.auth.company || null,
  };
};

export default connect(mapStateToProps)(withErrorHandler(RequestList, axios));



// WEBPACK FOOTER //
// ./src/containers/Request/RequestList.js